import { Card } from "@/components/ui/Card";
import StaffTableView from "./component/table";
import useDocumentTitle from "@/hooks/UseDocumentTitle";

export default function StaffManagement() {
  useDocumentTitle("Staff");

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <StaffTableView />
      </Card>
    </div>
  );
}
